import Axios from 'axios';
import * as SchoolRequest from '@/models/schoolRequest';
import * as SchoolResponse from '@/models/schoolResponse';

export type School = SchoolResponse.OrdinarySchoolEdit;
export type OrdinarySchool = SchoolResponse.OrdinarySchoolDetail;

interface State {
  loading: boolean;
  school: School | null;
}
const mapState: State = {
  loading: false,
  school: null
};

const mapActions = {
  async fetchSchool({ commit }: any, schoolId: string) {
    commit('setLoading', true);

    const request: SchoolRequest.OrdinarySchoolEditRequest = {
      schoolId,
      schoolName: undefined,
      ownerId: undefined,
      note: undefined,
      paymentMailaddress: undefined,
      subjectList: undefined,
      ordinarySchoolList: undefined,
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: undefined,
      availableFunctionTypes: undefined,
      reservableMonths: undefined,
      cancellationDays: undefined,
      isAutoEntryOrExit: undefined,
      collectionAgency: undefined,
    };
    const response = await Axios.post('/api/School/OrdinaryList', request).catch((error) => {
      commit('setLoading', false);
      throw error;
    });
    commit('fetchSchool', response.data);
  },
  async editSchool({ commit }: any, school: School) {
    const request: SchoolRequest.OrdinarySchoolEditRequest = {
      schoolId: school.schoolId,
      schoolName: undefined,
      ownerId: undefined,
      note: undefined,
      paymentMailaddress: undefined,
      subjectList: school.subjectList.map((item) => {
        return {
          id: item.id < 0 ? 0 : item.id,
          name: item.name,
          color: item.color,
        };
      }),
      ordinarySchoolList: school.ordinarySchoolList.map((item) => {
        return {
          ordinarySchoolId: /^NewOrdinarySchool/.test(item.ordinarySchoolId) ? null : item.ordinarySchoolId,
          ordinarySchoolName: item.ordinarySchoolName,
          schoolType: item.schoolType,
          termType: item.termType,
        };
      }),
      keyWord: undefined,
      perPage: undefined,
      page: undefined,
      sort: undefined,
      availableFunctionbit: undefined,
      availableFunctionTypes: undefined,
      reservableMonths: school.reservableMonths,
      cancellationDays: school.cancellationDays,
      isAutoEntryOrExit: school.isAutoEntryOrExit,
      collectionAgency: undefined,
    };
    const response = await Axios.post('/api/School/EditOrdinary', request).catch((error) => {
      throw new Error('スクール情報の変更に失敗しました。');
    });
    commit('changeSchool', school);
    return response.data;
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  fetchSchool(state: State, school: School) {
    state.school = school;
    state.loading = false;
  },
  changeSchool(state: State, school: School) {
    state.school = school;
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
